import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import axiosAuthInstance from '../../../utils/axios/axiosAuthInstance';
import { Field, FormikProvider, useFormik } from 'formik';
import CustomInput from '../../../components/common/CustomInput';
import * as Yup from 'yup';

const validationSchema = Yup.object({
  name: Yup.string().trim().required('Name is required'),
});

function Edit() {
  const navigate = useNavigate();
  const { id } = useParams();
  const [loading, setLoading] = useState(true);

  const formik = useFormik({
    initialValues: {
      name: '',
    },
    validationSchema,
    onSubmit: async (values) => {
      try {
        const response = await axiosAuthInstance.put(
          `big-task-type/update/${id}`,
          { name: values.name }
        );
        if (response.status === 200) {
          navigate('/bigtasktype');
        }
      } catch (error) {
        console.error('Update error:', error);
      }
    },
  });

  const fetchData = async () => {
    try {
      const response = await axiosAuthInstance.get(
        `big-task-type/detail/${id}`
      );
      if (response.status === 200) {
        formik.setValues({
          name: response.data.result?.name || '',
        });
        setLoading(false);
      }
    } catch (error) {
      console.error('Fetch error:', error);
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (loading) return <div className="text-center p-6">Loading...</div>;

  return (
    <FormikProvider value={formik}>
      <form
        className="flex flex-col p-4 gap-4"
        onSubmit={formik.handleSubmit}
      >
        <Field
          name="name"
          label="Name"
          placeholder="Enter Name"
          component={CustomInput}
        />

        <button
          type="submit"
          disabled={formik.isSubmitting}
          className="bg-primary text-white rounded-lg px-6 py-2 font-medium hover:bg-primary-dark"
        >
          Update
        </button>
      </form>
    </FormikProvider>
  );
}

export default Edit;
